import { storage } from 'APP/packages/storage';

export const resetFeedbackStorage = (): void => {
  storage.feedback.setDontShowValue(false);
  storage.feedback.resetSkipValue();
};
